export default {
    SKILLS: 1,
    TASKS: 2
}